export function cartableService(http) {
    const serviceName = "Cartable";

    return {
        //serviceName: "/Cartable",
        getCoordinator: (userId,roleMembers,pageNumber,pageSize,sortBy,startDate,endDate,cartableTypeId,filters) => {

            // var projectFilter=projectIds.map(item=>{
            //     return {
            //         member:"ProjectId",
            //         operator:"EqualTo",
            //         value:item
            //     }
            // });
            //debugger;
            const newSortBy=(sortBy||[]).map(item=>( {member:item.id,sortDirection:item.desc?"Descending":"Ascending"}))

            const newfilter= Object.keys(filters).map(key => {
                return {
                    member:key,
                    operator:filters[key].operator,
                    value: filters[key].columnType=="number"?Number(filters[key].value):filters[key].value
                };
              });
debugger;
            const filter= cartableTypeId==1
            ?{
                logic:"And",
                filters:[
                    ...newfilter,
                    {
                        member:"StartDate",
                        operator:"GreaterThanOrEqualTo",
                        value:startDate
                    },
                    {
                        member:"StartDate",
                        operator:"LessThan",
                        value:endDate
                    }
                ]
            }
            :newfilter.length>0 
                ?{
                    logic:"And",
                    filters:newfilter
                }
                :null;

            const data = {
                    user:{
                        id:userId
                    },
                    cartableTypeId,
                    startDate,
                    endDate,
                    roleMembers,
                    dataAttribute:{
                        page:pageNumber,
                        pageSize,
                        sorts:newSortBy.lenght==0?[{member:"StartDate",sortDirection:"Ascending"}]:newSortBy,
                        filter:filter
                    }
            };
            return http.post(serviceName + "/GetCoordinator",data);//.then(result=>result.data );
        },
        getHeadSection:(userId,roleMembers,pageNumber,pageSize,sortBy,cartableTypeId)=>{
            const newSortBy=(sortBy||[]).map(item=>( {member:item.id,sortDirection:item.desc?"Descending":"Ascending"}))
            var data={
                    user:{id:userId},
                    roleMembers,
                    cartableTypeId,
                    dataAttribute:{
                        page:pageNumber,
                        pageSize,
                        sorts:newSortBy.length>0?newSortBy:[{member:'KeyId',sortDirection:'Descending'}]
                    }
            };
            return http.post(serviceName + "/GetHeadSection",data)
        },
        getResponsible:(userId,roleMembers,pageNumber,pageSize,sortBy,cartableTypeId,filters)=>{
            
            const newfilter= Object.keys(filters).map(key => {
                return {
                    member:key,
                    operator:filters[key].operator,
                    value: filters[key].columnType=="number"?Number(filters[key].value):filters[key].value
                };
              });

            debugger;

            const newSortBy=(sortBy||[]).map(item=>( {member:item.id,sortDirection:item.desc?"Ascending":"Descending"}))
            //debugger;
            var data={
                user:{id:userId},
                roleMembers,
                cartableTypeId,
                dataAttribute:{
                    page:pageNumber,
                    pageSize,
                    sorts:newSortBy.lenfth>0?newSortBy: [{member:"AssignId",sortDirection:"Descending"}],
                    filter: newfilter.length>0
                        ? {
                            logic: "And",
                            filters: newfilter
                        }
                    :
                    null
                }
            };
            return http.post(serviceName + "/GetResponsible",data)
        }
    }
}